/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { BookingRules } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsBookingRules: build.query<BookingRules, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/booking` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsBookingRulesApi };
export const { useGetSettingsBookingRulesQuery, useLazyGetSettingsBookingRulesQuery } = injectedRtkApi;
